import parse, { domToReact } from 'html-react-parser';
import dynamic from 'next/dynamic';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import { toNormalizedUrl } from 'lib/htmlParsers/htmlParserUtils';
import { toFallbackImageAltText } from 'lib/image';
import { isYoutubeUrlValid } from 'lib/string';

import HTML_PARSER from 'constants/htmlParser';
import THIRD_PARTY from 'constants/thirdParty';

const Link = dynamic(() => import('shopper/components/Link'));
const Image = dynamic(() => import('components/Image'));

const threadOptions = {
  replace: (domNode) => {
    const { name, attribs, children } = domNode;

    if (!attribs) {
      return null;
    }

    if (name === HTML_PARSER.NAME_PARAGRAPH || name === HTML_PARSER.NAME_DIV) {
      if (
        children[0]?.data === '\n' ||
        children[0]?.name === HTML_PARSER.NAME_BR
      ) {
        return <></>;
      }

      return (
        <Text className="mb-4">{domToReact(children, threadOptions)}</Text>
      );
    }

    if (name === HTML_PARSER.NAME_H2) {
      return (
        <Heading as="h2" className="mb-4 mt-6" size="size3">
          {domToReact(children, threadOptions)}
        </Heading>
      );
    }

    if (name === HTML_PARSER.NAME_H3) {
      return (
        <Heading as="h3" className="mb-4 mt-6" size="size5">
          {domToReact(children, threadOptions)}
        </Heading>
      );
    }

    if (name === HTML_PARSER.NAME_HREF) {
      return (
        <Link
          className="inline"
          href={toNormalizedUrl(attribs.href)}
          target={attribs.target}
        >
          {domToReact(children, threadOptions)}
        </Link>
      );
    }

    if (name === HTML_PARSER.NAME_SPAN) {
      return <span>{domToReact(children, threadOptions)}</span>;
    }

    if (name === HTML_PARSER.NAME_IMAGE) {
      const { src, alt } = attribs;

      return (
        <Image
          alt={toFallbackImageAltText(alt)}
          className="mx-auto my-4 h-auto w-full"
          height={192}
          src={src}
          width={343}
          aria-hidden
        />
      );
    }

    if (name === HTML_PARSER.NAME_IFRAME && isYoutubeUrlValid(attribs?.src)) {
      return (
        <iframe
          allow={THIRD_PARTY.IFRAME_PERMISSIONS}
          className="max-w-full"
          height={450}
          loading="lazy"
          src={attribs.src}
          title={attribs.title}
          width="100%"
          allowFullScreen
        />
      );
    }
  },
};

const toThreadText = (forumThread) => parse(forumThread, threadOptions);

export default toThreadText;
